// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var MM_cmp_pe_stmt = require("./MM_cmp_pe_stmt.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Paper = require("@mui/material/Paper").default;
var Divider = require("@mui/material/Divider").default;
var MM_cmp_pe_frame_summary_state = require("./MM_cmp_pe_frame_summary_state.bs.js");

var paddingLeft = "5px";

function propsAreSame(a, b) {
  if (a.typeColors === b.typeColors && a.editStmtsByLeftClick === b.editStmtsByLeftClick && a.settings === b.settings && a.preCtx === b.preCtx && a.frame === b.frame) {
    return a.order === b.order;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var openFrameExplorer = param.openFrameExplorer;
        var order = param.order;
        var frame = param.frame;
        var parenCnt = param.parenCnt;
        var frms = param.frms;
        var syntaxTypes = param.syntaxTypes;
        var preCtx = param.preCtx;
        var settings = param.settings;
        var editStmtsByLeftClick = param.editStmtsByLeftClick;
        var typeColors = param.typeColors;
        var modalRef = param.modalRef;
        var match = React.useState(function () {
              return MM_cmp_pe_frame_summary_state.makeInitialState(preCtx, frame, typeColors);
            });
        var setState = match[1];
        var state = match[0];
        React.useEffect((function () {
                Curry._1(setState, (function (param) {
                        return MM_cmp_pe_frame_summary_state.makeInitialState(preCtx, frame, typeColors);
                      }));
              }), [
              typeColors,
              editStmtsByLeftClick,
              preCtx,
              frame,
              order
            ]);
        var actToggleDescrIsExpanded = function (param) {
          Curry._1(setState, MM_cmp_pe_frame_summary_state.toggleDescrIsExpanded);
        };
        var rndExpBtn = function (param) {
          if (Belt_Option.isSome(frame.descr)) {
            return React.createElement("span", undefined, Common.nbsp + Common.nbsp, React.createElement("span", {
                            style: {
                              color: "grey",
                              cursor: "pointer",
                              display: "inline-block",
                              fontFamily: "monospace",
                              fontSize: "1.5em",
                              fontWeight: "bold",
                              transform: state.descrIsExpanded ? "rotate(90deg)" : "none"
                            },
                            onClick: (function (param) {
                                return MM_react_common.clickHnd(undefined, undefined, undefined, undefined, actToggleDescrIsExpanded, undefined, param);
                              })
                          }, ">"));
          } else {
            return React.createElement(React.Fragment, undefined);
          }
        };
        var rndLabel = function (param) {
          var asrtType = frame.isAxiom ? React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, "Axiom") : React.createElement("span", {
                  style: {
                    color: "green"
                  }
                }, "Theorem");
          var tmp = {
            fontWeight: "bold",
            borderRadius: "3px"
          };
          var tmp$1 = MM_react_common.getFrmLabelBkgColor(frame, settings);
          if (tmp$1 !== undefined) {
            tmp.backgroundColor = tmp$1;
          }
          return React.createElement("span", {
                      style: {
                        paddingRight: paddingLeft,
                        paddingLeft: paddingLeft
                      }
                    }, React.createElement("span", {
                          style: {
                            cursor: "pointer"
                          },
                          onClick: (function (param) {
                              return MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function (param) {
                                            Curry._1(openFrameExplorer, frame.label);
                                          }), undefined, param);
                            })
                        }, String(order) + " ", asrtType, " ", React.createElement("span", {
                              style: tmp
                            }, frame.label)), rndExpBtn(undefined));
        };
        var rndDescr = function (param) {
          if (Belt_Option.isSome(frame.descr) && state.descrIsExpanded) {
            return React.createElement(React.Fragment, undefined, React.createElement(Divider, {}), React.createElement("div", {
                            style: {
                              paddingRight: paddingLeft,
                              paddingLeft: paddingLeft
                            }
                          }, Belt_Option.getWithDefault(frame.descr, "This assertion doesn't have any description.")));
          } else {
            return React.createElement(React.Fragment, undefined);
          }
        };
        var rndDisj = function (param) {
          var disj = state.disj;
          if (disj !== undefined) {
            return React.createElement(React.Fragment, undefined, React.createElement(Divider, {}), React.createElement("span", {
                            style: {
                              paddingRight: paddingLeft,
                              paddingLeft: paddingLeft
                            }
                          }, "Disj:" + MM_cmp_pe_frame_summary_state.disjGrpDelim, MM_cmp_pe_frame_summary_state.rndDisj(disj)));
          } else {
            return React.createElement("span", {
                        style: {
                          display: "none"
                        }
                      });
          }
        };
        var rndHyps = function (param) {
          if (state.eHyps.length === 0) {
            return React.createElement(React.Fragment, undefined);
          } else {
            return state.eHyps.map(function (hyp, i) {
                        return JsxPPXReactSupport.createElementVariadicWithKey(String(i), React.Fragment, {
                                    children: null
                                  }, [
                                    React.createElement(Divider, {}),
                                    React.createElement("table", {
                                          style: {
                                            paddingRight: paddingLeft,
                                            paddingLeft: paddingLeft
                                          }
                                        }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", {
                                                      style: {
                                                        verticalAlign: "top"
                                                      }
                                                    }, React.createElement("span", {
                                                          style: {
                                                            marginLeft: "10px"
                                                          }
                                                        }, Common.circleChar)), React.createElement("td", undefined, React.createElement(MM_cmp_pe_stmt.make, {
                                                          modalRef: modalRef,
                                                          ctx: state.frmCtx,
                                                          syntaxTypes: syntaxTypes,
                                                          frms: frms,
                                                          frameRestrict: settings.allowedFrms.inSyntax,
                                                          parenCnt: parenCnt,
                                                          stmt: hyp,
                                                          symColors: state.symColors,
                                                          symRename: state.symRename,
                                                          editStmtsByLeftClick: editStmtsByLeftClick
                                                        })))))
                                  ]);
                      });
          }
        };
        var rndAsrt = function (param) {
          return React.createElement("div", {
                      style: {
                        paddingRight: paddingLeft,
                        paddingLeft: paddingLeft
                      }
                    }, React.createElement(MM_cmp_pe_stmt.make, {
                          modalRef: modalRef,
                          ctx: state.frmCtx,
                          syntaxTypes: syntaxTypes,
                          frms: frms,
                          frameRestrict: settings.allowedFrms.inSyntax,
                          parenCnt: parenCnt,
                          stmt: state.asrt,
                          symColors: state.symColors,
                          symRename: state.symRename,
                          editStmtsByLeftClick: editStmtsByLeftClick
                        }));
        };
        return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Paper, {
                                    elevation: 3,
                                    style: {
                                      backgroundColor: "rgb(255,255,235)"
                                    },
                                    children: Caml_option.some(null)
                                  }, rndLabel(undefined), rndDescr(undefined), rndDisj(undefined), rndHyps(undefined), React.createElement(Divider, {}), rndAsrt(undefined))))));
      }), propsAreSame);

var paddingRight = paddingLeft;

exports.paddingLeft = paddingLeft;
exports.paddingRight = paddingRight;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
